export default __webpack_public_path__ + "static/media/airbnb-logo.263a33e4.svg";